/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Button,
  Image,
  Dropdown,
  Navbar as NavbarBs,
  NavLink,
  Badge,
  Card,
} from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useTranslate } from "../../../hooks/LanguageProvider";

import Logout from "../../Logout/Logout";
import { useTheme } from "../../../hooks/ThemeContext";
import usePermissions from "../../../hooks/usePermissions";
import { useUser } from "../../../context/UserContext";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import axios from "axios";

import "dayjs/locale/en";
import "dayjs/locale/fr";
import "dayjs/locale/ar";
import "dayjs/locale/es";
import { useAuth } from "../../../context/AuthContext";
import NavbarSearch from "./NavbarSearch";
import { alarmLabelKeys } from "../../../config/alarms/alarmLabelKeys";
import { toast } from "react-toastify";

dayjs.extend(relativeTime);

const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5002";
const backendUrlGeoParc = process.env.REACT_APP_BACKEND_URL_GEO_PARC;
const DEFAULT_USER_IMAGE = "/asset/images/default-user-aida.png";

interface NavbarProps {
  changNavbar: boolean;
  onToggleSidebarInNavbar: () => void;
}

interface Notification {
  id_notification: number;
  id_groupe_alarme: number;
  id_user: number;
  id_vehicule: number;
  id_conducteur: number;
  type: string;
  message: string;
  severity: number;
  timestamp: string;
  state: number;
}

const Navbar: React.FC<NavbarProps> = ({
  onToggleSidebarInNavbar,
  changNavbar,
}) => {
  const userName = localStorage.getItem("username");
  const [isOpen, setIsOpen] = useState("");
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [activeLogo, setActiveLogo] = useState("header-logo-show");
  const [activeMenuText, setActiveMenuText] = useState("");
  const [menuButtonSidebar, setMenuButtonSidebar] = useState(
    "iq-menu-bt-sidebar-show",
  );
  const [sidebar, setSidebar] = useState("sidebar-open");
  const [showMenu, setShowMenu] = useState("");
  const { lang, setLang } = useTranslate();

  const { logout } = useAuth(); // récupéré au début du composant

  dayjs.locale(lang);

  const navigate = useNavigate();
  const { translate } = useTranslate();
  const handleLanguageChange = (newLang: any) => {
    setLang(newLang);
  };
  const user_id = localStorage.getItem("userid");
  const APIkey = localStorage.getItem("api_key");
  const theme = localStorage.getItem("theme_mode");
  const strLang = {
    en: translate("English"),
    fr: translate("French"),
    ar: translate("Arabic"),
    es: translate("Espagnol"),
  };

  const { isDarkMode, toggleTheme } = useTheme();
  const { pathImg } = useUser();
  const [navbarAvatar, setNavbarAvatar] = useState<string>(DEFAULT_USER_IMAGE);

  const loadNavbarAvatar = useCallback(async () => {
    try {
      if (!user_id) {
        setNavbarAvatar(DEFAULT_USER_IMAGE);
        return;
      }

      const res = await axios.get(
        `${backendUrl}/api/suppliers/profile/${user_id}`,
      );

      if (res.data?.logo) {
        const logoPath = String(res.data.logo).startsWith("http")
          ? res.data.logo
          : `${backendUrl}${res.data.logo}`;
        setNavbarAvatar(logoPath);
      } else if (pathImg) {
        setNavbarAvatar(pathImg);
      } else {
        setNavbarAvatar(DEFAULT_USER_IMAGE);
      }
    } catch (error) {
      console.error("Error loading navbar avatar:", error);

      if (pathImg) {
        setNavbarAvatar(pathImg);
      } else {
        setNavbarAvatar(DEFAULT_USER_IMAGE);
      }
    }
  }, [user_id, pathImg]);

  // Utilisation du hook
  const handleLogout = async () => {
    try {
      await logout(); // ⬅️ logout vient du contexte (useAuth)
      //navigate("/login"); // ⬅️ navigation après déconnexion
    } catch (error) {
      console.error("Error during disconnection: ", error);
    }
  };

  const [dropdownOpenNotification, setDropdownOpenNotification] =
    useState(false);
  const [dropdownOpenProfile, setDropdownOpenProfile] = useState(false);

  const handleToggleProfile = (DropdownOpen: any) => {
    setDropdownOpenProfile(DropdownOpen);
  };

  const handleSetIsOpen = () => {
    isOpen == "open" ? setIsOpen("") : setIsOpen("open");

    sidebar == "sidebar-close"
      ? setSidebar("sidebar-open")
      : setSidebar("sidebar-close");

    activeLogo == "header-logo-show"
      ? setActiveLogo("header-logo-hide")
      : setActiveLogo("header-logo-show");
    activeMenuText == "iq-menu-span-hide"
      ? setActiveMenuText("")
      : setActiveMenuText("iq-menu-span-hide");
    menuButtonSidebar == "iq-menu-bt-sidebar-show"
      ? setMenuButtonSidebar("iq-menu-bt-sidebar-hide")
      : setMenuButtonSidebar("iq-menu-bt-sidebar-show");
  };

  const toggleMenu = () => {
    setShowMenu(showMenu === "" ? "show" : "");
  };

  const getNotifications = async (id_user: string, state: number) => {
    try {
      // Prepare the request body
      const bodyData = JSON.stringify({
        id_user: parseInt(id_user),
        state,
        limitValue: 100,
      });

      // Make the fetch request
      const response = await fetch(`${backendUrl}/api/notification/read`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyData,
        mode: "cors",
      });

      // Check if the response status is OK (status code 200)
      if (!response.ok) {
        throw new Error(
          `Request failed with status ${response.status}: ${response.statusText}`,
        );
      }

      // Parse the JSON response
      const alarmResponse = await response.json();

      // Set the notifications state
      setNotifications(alarmResponse);
    } catch (error) {
      console.error("Error fetching alarms:", error);

      setNotifications([]);
      // Display a user-friendly message or handle the error in your UI logic
      // toast.error("An error occurred while fetching alarms. Please try again later.");
    }
  };

  useEffect(() => {
    if (user_id) {
      getNotifications(user_id, 1);

      const interval = setInterval(() => {
        getNotifications(user_id, 1);
      }, 10000); // 10,000ms = 10 seconds

      return () => clearInterval(interval);
    }
  }, [user_id]);

  useEffect(() => {
    loadNavbarAvatar();
  }, [loadNavbarAvatar]);

  useEffect(() => {
    const handleProfileUpdated = () => {
      loadNavbarAvatar();
    };

    window.addEventListener("profile-updated", handleProfileUpdated);

    return () => {
      window.removeEventListener("profile-updated", handleProfileUpdated);
    };
  }, [loadNavbarAvatar]);

  const handleToggleNotification = () => {
    setDropdownOpenNotification(!dropdownOpenNotification);
  };

  const [isDarkTheme, setIsDarkTheme] = useState<boolean>(
    theme == "1" ? true : false,
  );

  // Use useEffect to save the theme in localStorage
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme_mode");
    if (savedTheme === "1") {
      setIsDarkTheme(true);
      document.body.classList.add("dark-theme");
    } else {
      setIsDarkTheme(false);
      document.body.classList.add("light-theme");
    }
  }, []);

  // Save the selected theme in localStorage
  useEffect(() => {
    localStorage.setItem("theme_mode", isDarkTheme ? "1" : "0");
  }, [isDarkTheme]);

  const roleId = localStorage.getItem("id_role");
  const { userPermissions } = usePermissions(roleId);
  const checkPermission = (idPermission: number): boolean => {
    return userPermissions.some(
      (permission) => permission.id_permission === idPermission,
    );
  };

  const getLabelFromType = (value: string): string => {
    const entry = Object.entries(alarmLabelKeys).find(([, v]) => v === value);
    return entry ? entry[0] : value;
  };

  const handleLoginGeoParc = async () => {
    console.log("LogIn GeoParc");

    const toastId = toast.loading(translate("logging_in"), {
      position: "bottom-right",
    });

    try {
      const response = await axios.post(
        `${backendUrl}/api/loginGeoParc`,
        { api_key: APIkey },
        { withCredentials: true },
      );

      const data = response.data;

      if (!data || !data.id_user) {
        toast.update(toastId, {
          render: translate("invalid_credentials"),
          type: "error",
          isLoading: false,
          autoClose: 3000,
          position: "bottom-right",
        });
        return;
      }

      // ✅ (B) ICI = on ENREGISTRE GeoParc
      const GeoParcLoginTime = Date.now();
      localStorage.setItem("GeoploginTime", String(GeoParcLoginTime));
      localStorage.setItem("GeopUserID", String(data.id_user));
      localStorage.setItem("Geopusername", String(data.username));

      // 👉 IMPORTANT: on met tout GeoParc en namespace (pas de conflit)
      localStorage.setItem("geop_api_key", String(data.api_key));
      localStorage.setItem("geop_id_role", String(data.id_role));
      localStorage.setItem(
        "geop_theme_mode",
        String(data.profile_settings?.theme_mode ?? "0"),
      );
      localStorage.setItem(
        "geop_language",
        String(data.profile_settings?.language ?? "fr"),
      );
      localStorage.setItem(
        "geop_timezone",
        String(data.profile_settings?.timezone ?? ""),
      );

      toast.update(toastId, {
        render: translate("login_success_redirect"),
        type: "success",
        isLoading: false,
        autoClose: 1500,
        position: "bottom-right",
      });

      // ✅ (C) ICI = on va vers GeoParc (reload propre)
      window.location.replace(`${backendUrlGeoParc}`);
    } catch (error: any) {
      console.error("Login GEOP depuis GEOT error", error);

      toast.update(toastId, {
        render: error?.response?.data?.message || translate("login_failed"),
        type: "error",
        isLoading: false,
        autoClose: 3000,
        position: "bottom-right",
      });
    }
  };

  const getRoleLabel = () => {
    switch (roleId) {
      case "1":
        return translate("administrator");
      case "2":
        return translate("supplier_user");
      case "3":
        return translate("oem_user");
      default:
        return translate("User");
    }
  };

  const getProfileRoute = () => {
    switch (roleId) {
      case "1":
        return "/profile";
      case "2":
        return "/supplier_profile";
      case "3":
        return "/oem-profile";
      default:
        return "/profile";
    }
  };

  return (
    <div
      className={`iq-top-navbar  ${changNavbar ? "navbar-push" : "navbar-pool"}`}
    >
      <div className="iq-navbar-custom">
        <nav className="navbar navbar-expand-lg navbar-light p-0">
          <div className="iq-navbar-logo d-flex align-items-center justify-content-between">
            <i
              className={` wrapper-menu `}
              onClick={() => {
                handleSetIsOpen();
                onToggleSidebarInNavbar();
              }}
            >
              {" "}
            </i>

            <Nav.Link to="/" className={`header-logo`} as={NavLink}>
              <Image
                className="img-fluid rounded-normal light-logo"
                style={{ height: "22px", width: "136px", paddingLeft: 15 }}
                src={
                  isDarkMode
                    ? "asset/images/logo_dark.png"
                    : "asset/images/logo.png"
                }
                alt="Logo"
              />
            </Nav.Link>

            <NavbarSearch />
          </div>

          <div className="d-flex align-items-center">
            <button
              onClick={toggleMenu}
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-label="Toggle navigation"
              aria-expanded="true"
            >
              <i className="ri-menu-3-line"></i>
            </button>
            <div
              className={`navbar-collapse collapse ${showMenu}`}
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ml-auto navbar-list align-items-center">
            

                <li
                  className="nav-item nav-icon dropdown"
                  style={{ margin: "0 5px" }}
                >
                  <NavDropdown
                    title={
                      <span>
                        <img
                          src={`asset/images/small/flag-${lang}.png`}
                          alt={lang}
                        />
                        <span> {strLang[lang]}</span>
                      </span>
                    }
                    id="navbarScrollingDropdown"
                  >
                    <NavDropdown.Item
                      onClick={() => handleLanguageChange("en")}
                    >
                      <img
                        src="asset/images/small/flag-en.png"
                        alt="img-flag"
                        className="img-fluid image-flag mr-2"
                      />{" "}
                      {translate("English")}
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      onClick={() => handleLanguageChange("fr")}
                    >
                      <img
                        src="asset/images/small/flag-fr.png"
                        alt="img-flag"
                        className="img-fluid image-flag mr-2"
                      />{" "}
                      {translate("French")}
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      onClick={() => handleLanguageChange("ar")}
                    >
                      <img
                        src="asset/images/small/flag-ar.png"
                        alt="img-flag"
                        className="img-fluid image-flag mr-2"
                      />{" "}
                      {translate("Arabic")}
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      onClick={() => handleLanguageChange("es")}
                    >
                      <img
                        src="asset/images/small/flag-es.png"
                        alt="img-flag"
                        className="img-fluid image-flag mr-2"
                      />{" "}
                      {translate("Spanish")}
                    </NavDropdown.Item>
                  </NavDropdown>
                </li>

                <li
                  className="nav-item nav-icon dropdown"
                  style={{ margin: "0 5px" }}
                >
                  <div
                    className="dropdown"
                    onClick={toggleTheme}
                    style={{ cursor: "pointer" }}
                  >
                    {/* Display the icon based on the theme */}
                    {isDarkTheme ? (
                      <i
                        className="las la-moon"
                        style={{ fontSize: "22px" }}
                      ></i> // Moon icon for dark theme
                    ) : (
                      <i
                        className="las la-sun"
                        style={{ fontSize: "22px" }}
                      ></i> // Sun icon for light theme
                    )}
                  </div>
                </li>

                <li
                  className="nav-item nav-icon dropdown show"
                  style={{ margin: "0 5px" }}
                >
                  <Dropdown onToggle={handleToggleNotification}>
                    <Dropdown.Toggle
                      as="span"
                      id="dropdownMenuButton5"
                      className="search-toggle"
                      href="#"
                    >
                      <div className="notification-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-bell"
                        >
                          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                        </svg>
                        {notifications && notifications.length > 0 && (
                          <span className="notification-badge">
                            {notifications.length >= 100
                              ? "99+"
                              : notifications.length}
                          </span>
                        )}
                      </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      align="end"
                      className="iq-sub-dropdown dropdown-menu"
                      show={dropdownOpenNotification}
                      aria-labelledby="dropdownMenuButton5"
                    >
                      <Card className="shadow-none m-0">
                        <Card.Body className="p-0">
                          <div className="custom-title p-3">
                            <div className="d-flex align-items-center justify-content-between">
                              <h5 className="mb-0">{translate("notifications")}</h5>
                              <Badge className="badge-card">
                                {notifications && notifications.length >= 100
                                  ? "99+"
                                  : notifications.length}
                              </Badge>
                            </div>
                          </div>
                          <div className="px-3 pt-0 pb-0 sub-card">
                            {notifications && notifications.length > 0 ? (
                              notifications.slice(0, 7).map((notification) => (
                                <Link
                                  className="iq-sub-card"
                                  key={notification.id_notification}
                                  to={`/notifications/${notification.id_notification}?t=${Date.now()}`}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="View notification"
                                  onClick={() => {
                                    fetch(
                                      `${backendUrl}/api/notification/update`,
                                      {
                                        method: "POST",
                                        headers: {
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                          id_notification:
                                            notification.id_notification,
                                        }),
                                      },
                                    )
                                      .then((response) => response.json())
                                      .then((data) => {
                                        if (user_id)
                                          getNotifications(user_id, 1);
                                        console.log(
                                          "Updated notifications :",
                                          data,
                                        );
                                      })
                                      .catch((error) => {
                                        console.error(
                                          "None during the update :",
                                          error,
                                        );
                                      });

                                    setTimeout(() => {
                                      setDropdownOpenNotification(false);
                                      window.location.reload();
                                    }, 10);
                                  }}
                                >
                                  <div
                                    className="media align-items-center custom-card py-3 border-bottom"
                                    style={{
                                      paddingBottom: "0.5rem !important",
                                    }}
                                  >
                                    <div>
                                      <img
                                        className="avatar-30 rounded-small"
                                        src="../asset/images/icon-report/3.png"
                                        alt="01"
                                      />
                                    </div>
                                    <div className="media-body ml-3">
                                      <div className="d-flex align-items-center justify-content-between">
                                        <h6
                                          className="mb-0"
                                          style={{ fontSize: "13px" }}
                                        >
                                          {translate(
                                            getLabelFromType(notification.type),
                                          )}
                                        </h6>
                                        <small className="">
                                          <b>
                                            {dayjs(
                                              dayjs(notification.timestamp).add(
                                                1,
                                                "hour",
                                              ),
                                            ).fromNow()}
                                          </b>
                                        </small>
                                      </div>
                                      <small className="mb-0">
                                        {notification.message}
                                      </small>
                                    </div>
                                  </div>
                                </Link>
                              ))
                            ) : (
                              <p className="text-center p-2">
                                {translate("no_notifications_available")}
                              </p>
                            )}
                          </div>
                          <>
                            <Link
                              to="/notifications"
                              className="right-ic btn btn-primary btn-block position-relative p-2"
                            >
                              {translate("see_all_notifications")}{" "}
                              <i className="las la-arrow-right"></i>
                            </Link>
                          </>
                        </Card.Body>
                      </Card>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>

                <li
                  className="nav-item nav-icon dropdown"
                  style={{ margin: "0 5px" }}
                >
                  <Dropdown
                    onToggle={handleToggleProfile}
                    show={dropdownOpenProfile}
                  >
                    <Dropdown.Toggle
                      as="span"
                      id="dropdownMenuButton4"
                      className="search-toggle"
                      href="#"
                    >
                      <img
                        src={navbarAvatar}
                        alt="avatar"
                        className="rounded-circle"
                        style={{
                          width: 36,
                          height: 36,
                          objectFit: "cover",
                          border: "1px solid #e5e7eb",
                        }}
                        onError={(e: any) => {
                          e.currentTarget.src = DEFAULT_USER_IMAGE;
                        }}
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="dropdownProfile p-0 shadow border-0"
                      style={{ minWidth: "260px", borderRadius: "10px" }}
                    >
                      {/* HEADER USER (comme ton template) */}
                      <div className="px-3 py-3 border-bottom">
                        <div className="d-flex align-items-center">
                          {/* AVATAR */}
                          <div className="me-2">
                            <img
                              src={navbarAvatar}
                              alt="avatar"
                              className="rounded-circle"
                              style={{
                                width: 45,
                                height: 45,
                                objectFit: "cover",
                              }}
                              onError={(e: any) => {
                                e.currentTarget.src = DEFAULT_USER_IMAGE;
                              }}
                            />
                          </div>

                          {/* USER INFO */}
                          <div className="flex-grow-1">
                            <h6 className="mb-0">{userName || "User"}</h6>
                            <small className="text-muted">
                              {translate(getRoleLabel())}
                            </small>
                          </div>
                        </div>
                      </div>

                      {/* DIVIDER */}
                      <div className="dropdown-divider m-0"></div>

                      {/* MENU */}
                      <button
                        className="dropdown-item d-flex align-items-center"
                        onClick={() => navigate(getProfileRoute())}
                      >
                        <i className="las la-user me-2"></i>
                        {translate("Profile")}
                      </button>

                      <button className="dropdown-item d-flex align-items-center">
                        <i className="las la-cog me-2"></i>
                        {translate("Settings")}
                      </button>

                      <button className="dropdown-item d-flex align-items-center">
                        <i className="las la-file-invoice-dollar me-2"></i>
                        {translate("rfqs")}
                        <span className="badge bg-danger ms-auto">4</span>
                      </button>

                      <div className="dropdown-divider m-0"></div>

                      <button className="dropdown-item d-flex align-items-center">
                        <i className="las la-question-circle me-2"></i>
                        {translate("FAQ")}
                      </button>

                      {/* LOGOUT BUTTON (comme template) */}
                      <div style={{ padding: "10px 12px" }}>
                        <div
                          style={{
                            background: "#ffd02a",
                            borderRadius: "6px",
                            textAlign: "center",
                            padding: "2px 5px",
                            cursor: "pointer",
                          }}
                        >
                          <span
                            style={{
                              color: "#fff",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Logout
                              onLogout={handleLogout}
                              activeMenu={""}
                              title={translate("Logout")}
                              margin={""}
                            />
                          </span>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
